// TODO: consolidate all client-side cookie handling here.

export function readCookie(name: string): string | null {
    const escapedName = name.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)', 'u'));
    if (!match) {
        return null;
    }
    try {
        return decodeURIComponent(match[1]).replace(/^"|"$/gu, '');
    } catch {
        return match[1];
    }
}

/**
 * Set a cookie with our standard attributes, returning false if it could not be read back
 * afterwards (e.g. the browser blocked it).
 *
 * Uses `SameSite=None; Secure` over https so the cookie survives cross-origin scenarios (the B2C
 * sign-in redirect, links from emails, and Open Access iframe embedding). Over http (DEV) it falls
 * back to `SameSite=Lax` without `Secure`, because Chrome rejects `SameSite=None` without `Secure`.
 */
export function setCookie(name: string, value: string, maxAgeSeconds: number): boolean {
    const isHttp = window.location.protocol === 'http:';

    // Require a secure connection (https) to set the cookie, unless we're running in DEV over http.
    const secure = isHttp ? '' : ' Secure;';
    const sameSite = isHttp ? 'Lax' : 'None';

    document.cookie = `${name}=${encodeURIComponent(value)}; SameSite=${sameSite};${secure} path=/; Max-Age=${maxAgeSeconds}`;

    // If we can't read the cookie back, it probably wasn't set, so let the caller know.
    return readCookie(name) === value;
}

export function purgeCookieFromAllScopes(name: string): void {
    const encodedName = encodeURIComponent(name);
    const expired = `${encodedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = expired;
    const parts = window.location.hostname.split('.');
    for (let i = 0; i < parts.length - 1; i++) {
        const domain = parts.slice(i).join('.');
        document.cookie = `${expired}; domain=${domain}`;
        document.cookie = `${expired}; domain=.${domain}`;
    }
}

export function purgeCookieFromParentScopes(name: string): void {
    const encodedName = encodeURIComponent(name);
    const expired = `${encodedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    const parts = window.location.hostname.split('.');
    for (let i = 1; i < parts.length - 1; i++) {
        const domain = parts.slice(i).join('.');
        document.cookie = `${expired}; domain=${domain}`;
        document.cookie = `${expired}; domain=.${domain}`;
    }
}
